module.exports = __webpack_public_path__ + "img/close-modal.23f28cc7.svg";